import {defaultNiveles, defaultUbicacion, defaultUbicacionEmpresa, filtro} from './state';

export function setNiveles(state, dato) {
  state.niveles = dato;
}

export function setNivelesActivos(state, dato) {
  state.nivelesActivos = [];
  let cont = 0;
  dato.forEach(element => {
    state.nivelesActivos.push({
      id_nivel: element.id,
      value: cont++,
      text: 'Nivel ' + element.nivel + ' ' + element.descripcion,
      nivel: element.nivel
    });
  });
}

export function setSelectedNivel(state, dato) {
  state.selectedNivel.id = dato.id;
  state.selectedNivel.descripcion = dato.descripcion;
  state.selectedNivel.nivel = dato.nivel;
}

export function setSelectedUbicacion(state, ubicacion) {
  state.selectedUbicacion = JSON.parse(JSON.stringify(ubicacion));
}

export function setUbicaciones(state, dato) {
  state.ubicaciones = [];
  state.ubicaciones = dato;
}

export function setUbicacionesPadre(state, dato) {
  if (dato) {
    state.selectedUbicacionEmpresa.id_parent = dato.id;
  } else {
    state.selectedUbicacionEmpresa.id_parent = '';
  }
}

export function setUbicacionesEmpresa(state, dato) {
  state.ubicacionEmpresa = [];
  let cont = 0;
  if (dato == '') {
    state.selectedUbicacionEmpresa.id_parent = 0;
    dato.forEach(element => {
      state.ubicacionEmpresa.push({
        id_nivel: element.id,
        value: cont++,
        text: element.descripcion + ' Nivel ' + element.get_nivel.nivel,
      });
    });
  } else {
    dato.forEach(element => {
      state.ubicacionEmpresa.push({
        id_nivel: element.id,
        value: cont++,
        text: element.descripcion + ' Nivel ' + element.get_nivel.nivel,
      });
    });
  }
}

/**
 * Mutación para confirmar la inactivación de las ubicaciones
 *
 * @export
 * @param {*} state
 * @param {*} data datos necesarios para el proceso
 */
export function setConfirmarEliminado(state, data) {
  Object.assign(state.selectedUbicacionEmpresa, data);
}

export function setUbicacionEmpresa(state, data) {
  state.selectedUbicacionEmpresa = data;
}

export function setArbolEmpresa(state, dato) {
  state.arbolUbicaciones = [];
  state.arbolUbicaciones = dato.data;
}

export function setIdUbicacion(state, id) {
  state.selectedUbicacionEmpresa.id_ubicacion = id;
}

export function setIdParent(state, dato) {
  state.selectedUbicacionEmpresa.id_parent = dato;
}

export function setIdUbicacionParent(state, id) {
  state.ubicacionParent.ubicacion = id.id_nivel;
}

export function accionError(state) {
  state.error = true;
}

export function setFiltro(state, info) {
  state.ubicacionAsig.id_nivel = info.id_nivel;
}

export function setFiltroNivel(state, info) {
  state.filtro.ubicacion = info.ubicacion;
  state.filtro.id_nivel = info.id_nivel;
}

export function resetOptions(state) {
  state.nivelesActivos = [];
  state.ubicacionEmpresa = [];
  state.selectedUbicacion.id = '';
  state.ubicacionParent.id = '';

}

export function resetSelectedNivel(state) {
  Object.assign(state.selectedNivel, defaultNiveles());
}

export function resetSelectedUbicacion(state) {
  state.nivelesActivos = [];
  Object.assign(state.selectedUbicacion, defaultUbicacion());
}

export function resetSelectedUbicacionEmpresa(state) {
  state.ubicacionEmpresa = [];
  Object.assign(state.selectedUbicacionEmpresa, defaultUbicacionEmpresa());
}

export function getSelectedArbolUbicacion(state, ubicacion) {
  Object.assign(state.selectedUbicacionEmpresa, ubicacion);
}

export function setEnlazarUbicacion(state, data) {
  state.selectedUbicacion.id_nivel = data.id_nivel;
  state.selectedUbicacion.nivel = data.nivel;
  state.ubicacionAsig.nivel = data.nivel;
}

export function setEnlazar(state, data) {
  state.ubicacionAsig.nivel = data.nivel;
}

export function setModal(state, ver) {
  state.modal.ver = ver;
}

export function setPaso(state, paso) {
  state.modal.paso = paso;
}

export function setPage(state, page) {
  state.filtro.page = page;
}

export function resetFiltroNiveles(state) {
  state.filtro_niveles.descripcion = '';
}

export function establecerAccionNiveles(state, accion) {
  state.accion_niveles = accion;
}

export function establecerModalNiveles(state, ver) {
  state.modal_niveles.ver = ver;
}


export function establecerModalUbicaciones(state, ver) {
  state.modal_ubicaciones.ver = ver;
}

export function resetFiltroUbicaciones(state) {
  Object.assign(state.filtro, filtro());
}

export function establecerAsociar(state, asociar) {
  state.asociar = asociar;
}


